import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv } from '../TextStyle'
import { snsItems, snsLinks } from './SNSItems'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Index } from '@/components/layouts/Legal/Index'

const sectionTitle = {
  titleText: 'Social Media Policy',
  subTitleText: 'トライアルグループ ソーシャルメディア公式アカウント利用規約',
}

export const SNSPage = () => {
  return (
    <>
      <Head
        title="SNSポリシー"
        description="トライアルホールディングスのSNSポリシーを掲載しています。"
        ogp={{ type: 'article', url: 'legal/sns-policy/' }}
      />
      <SnsContainer>
        <CompleteTitle>
          <SectionTitle
            color="normal"
            titleText={sectionTitle.titleText}
            subTitleText={sectionTitle.subTitleText}
          />
        </CompleteTitle>
        <Spacer h={{ pc: 70, sp: 60 }} />
        <Index columnGap={25} listType="article" links={snsLinks} />
        <Spacer h={{ pc: 70, sp: 39 }} />
        {snsItems.map(({ children, id }, index) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < snsItems.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </SnsContainer>
    </>
  )
}
SNSPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '法務',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '法務', path: '/legal/' },
    { name: 'SNSポリシー', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const SnsContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`

const CompleteTitle = styled.div`
  width: 100%;
  margin: 0 auto;
  @media screen and (max-width: 1047px) {
    max-width: 200px;
  }
`
